/**
 * Per-viewer layout preferences (collapsed tree / rail). Browser storage can throw
 * (private mode, blocked site data), so every access is guarded and the UI falls
 * back to the defaults.
 */
const PREFS_KEY = 'taxonomy-studio:prefs';

export interface TaxonomyPrefs {
  railCollapsed: boolean;
  treeCollapsed: boolean;
  /** The edit → review → publish hint was dismissed. */
  hintDismissed: boolean;
}

const DEFAULT_PREFS: TaxonomyPrefs = {
  railCollapsed: false,
  treeCollapsed: false,
  hintDismissed: false,
};

export function readPrefs(): TaxonomyPrefs {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) return DEFAULT_PREFS;
    const parsed = JSON.parse(raw) as Partial<TaxonomyPrefs>;
    return {
      railCollapsed: parsed.railCollapsed === true,
      treeCollapsed: parsed.treeCollapsed === true,
      hintDismissed: parsed.hintDismissed === true,
    };
  } catch {
    return DEFAULT_PREFS;
  }
}

export function writePrefs(patch: Partial<TaxonomyPrefs>): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify({ ...readPrefs(), ...patch }));
  } catch {
    /* storage unavailable: the preference lives for this visit only */
  }
}
